import React, { ChangeEvent } from "react";
import TextField, { type TextFieldProps } from "../TextField";
import { applyMask } from "@/utils/functions/formatMask";

export interface MaskedTextFieldProps extends Omit<TextFieldProps, "onChange"> {
  format: string;
  // eslint-disable-next-line no-unused-vars
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const MaskedTextField = ({
  onChange,
  format,
  value,
  ...props
}: MaskedTextFieldProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const maskedValue = applyMask(inputValue, format);
    const maskedEvent = {
      ...event,
      target: {
        ...event.target,
        value: maskedValue
      }
    } as ChangeEvent<HTMLInputElement>;

    onChange?.(maskedEvent);
  };

  return <TextField {...props} value={value} onChange={handleChange} />;
};

export default MaskedTextField;
